import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EntityService } from '../../core/services/entity.service';
import { ModuleEntity } from '../module.entity';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { LearningUnitEntityService } from '../../learning-unit/services/learning-unit.entity.service';
import { ConsumerEntityService } from '../../consumer/services/consumer.entity.service';
import { SubjectEntityService } from '../../subject/services/subject.entity.service';
import { SchoolClassEntityService } from '../../core/global-enums/school-class/services/school-class.entity.service';

export const STATE_NAME = 'moduleEntity';

// Create the NGXS state for modules
export const ModuleEntityState: GenericEntityStateClass<ModuleEntity> =
  createEntityState<ModuleEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class ModuleEntityService extends EntityService<ModuleEntity> {
  private http = inject(HttpClient);
  private learningUnitService = inject(LearningUnitEntityService);
  private consumerEntityService = inject(ConsumerEntityService);
  private subjectEntityService = inject(SubjectEntityService);
  private schoolClassService = inject(SchoolClassEntityService);

  constructor() {
    super();
    this.resourceType = 'modules';
    this.stateClass = ModuleEntityState;

    this.registerRelation('learning-units', this.learningUnitService);
    this.registerRelation('consumers', this.consumerEntityService);
    this.registerRelation('subjects', this.subjectEntityService);
    this.registerRelation('schoolClasses', this.schoolClassService);
  }

  reorder(moduleId: string, afterModuleId: string | null, consumerId: string | null, canton: string | null): Observable<{ data: { id: string, order: Record<string, string> } }> {
    return this.http.post<{ data: { id: string, order: Record<string, string> } }>(
      `${environment.apiUrl}/modules/${moduleId}/reorder`,
      { after_module_id: afterModuleId, consumer_id: consumerId, canton }
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): ModuleEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
